// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `menu {
    position: absolute;
    width: 4rem;
    height: calc(100vh - 3rem);
    top: 3rem;
    background-color: var(--branco-padrao);
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    z-index: 1001;
    transition: width 0.3s ease;
    overflow: hidden;
}

.logo-banner-dixi {
    width: 3rem;
    margin-top: 2rem;
    transition: transform .3s ease-in-out;
    cursor: pointer;
}

menu:hover .logo-banner-dixi {
    transform: scale(3);
}

menu ul {
    list-style: none;
    width: 100%;
    display: flex;
    gap: .4rem;
    flex-direction: column;
}

menu ul li, menu ul .container-dropdown-cadastros {
    display: flex;
    justify-content: start;
    padding-left: .3rem;
    padding-right: .3rem;
    list-style: none;
    width: 100%;
    position: relative;
}

.container-dropdown-cadastros {
    display: flex;
    flex-direction: column;
}

.seta-dropdown-cadastros {
    position: absolute;
    font-size: 1.8rem;
    right: -1.8rem;
    top: 0rem;
    pointer-events: none;
}

.container-dropdown-cadastros li {
    padding: 0;
}

.container-dropdown-cadastros li a span {
    padding-left: .6rem;
}

.dropdown-cadastros {
    display: none;
}

.dropdown-cadastros a {
    text-decoration: none;
    color: var(--text-color2);
    font-size: .9rem;
    margin-top: .3rem;
    margin-left: 3.7rem;
    padding-top: .4rem;
    padding-bottom: .4rem;
    width: max-content;
    min-width: 65%;
    font-weight: bold;
}

.dropdown-cadastros a:hover {
    background-color: var(--azul-desativado);
    color: var(--texto-azul);
}

.sub-meun-dropdown {
    display: flex;
    align-items: center;
}

#tela-atual-sub-menu {
    border-left: 5px solid var(--azul-dixi);
    border-radius: 0 8px 8px 0;
    color: var(--azul-dixi);
}

#nao-e-tela-atual-sub-menu {
    border-radius: 8px;
}

.seta-dropdown-cadastros.tela-atual {
    color: var(--branco-padrao);
}

.dropdown-aberto {
    display: block;
}

.tooltip-navbar-lateral {
    position: absolute;
    width: max-content;
    color: var(--text-color);
    padding: .35rem .9rem;
    font-size: 1rem;
    font-weight: 600;
    align-items: center;
    left: 3.3rem;
    top: .55rem;
    border-radius: 1rem;
    transition: all .3s ease-in-out;

    transition: opacity 0.3s ease, visibility 0.3s ease;
}

menu ul li a {
    text-decoration: none;
    color: var(--azul-dixi);
    font-size: 1.3rem;
    padding: .8rem 1rem .6rem 1rem;
    border-radius: .8rem;
    transition: all .3s;
    width: 100%;
}

menu ul li a:hover {
    background: var(--botao-hover-clarinho);
}

#main-menu {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.tela-atual a {
    background: var(--azul-dixi);
    color: var(--branco-padrao);
}

.tela-atual span {
    color: var(--branco-padrao);
}

menu:hover {
    width: 14rem;
}

.tela-atual a:hover {
    cursor: pointer;
    background: var(--botao-hover);
    color: var(--branco-padrao);
}

#menu-inferior {
    margin-top: auto;
    margin-bottom: 2rem;
}

.botao-sair a {
    color: var(--vermelho-padrao);
}

.botao-sair a:hover {
    background: var(--vermelho-padrao);
    color: var(--branco-padrao);
}

li:hover .tooltip-navbar-lateral {
    opacity: 1;
    visibility: visible;
}`, "",{"version":3,"sources":["webpack://./src/components/MenuLateral/MenuLateral.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,0BAA0B;IAC1B,SAAS;IACT,sCAAsC;IACtC,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uCAAuC;IACvC,aAAa;IACb,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,wCAAwC;IACxC,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,uCAAuC;IACvC,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,wBAAwB;IACxB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,+BAA+B;;IAE/B,mDAAmD;AACvD;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,iBAAiB;IACjB,8BAA8B;IAC9B,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kCAAkC;IAClC,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB","sourcesContent":["menu {\n    position: absolute;\n    width: 4rem;\n    height: calc(100vh - 3rem);\n    top: 3rem;\n    background-color: var(--branco-padrao);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n    z-index: 1001;\n    transition: width 0.3s ease;\n    overflow: hidden;\n}\n\n.logo-banner-dixi {\n    width: 3rem;\n    margin-top: 2rem;\n    transition: transform .3s ease-in-out;\n    cursor: pointer;\n}\n\nmenu:hover .logo-banner-dixi {\n    transform: scale(3);\n}\n\nmenu ul {\n    list-style: none;\n    width: 100%;\n    display: flex;\n    gap: .4rem;\n    flex-direction: column;\n}\n\nmenu ul li, menu ul .container-dropdown-cadastros {\n    display: flex;\n    justify-content: start;\n    padding-left: .3rem;\n    padding-right: .3rem;\n    list-style: none;\n    width: 100%;\n    position: relative;\n}\n\n.container-dropdown-cadastros {\n    display: flex;\n    flex-direction: column;\n}\n\n.seta-dropdown-cadastros {\n    position: absolute;\n    font-size: 1.8rem;\n    right: -1.8rem;\n    top: 0rem;\n    pointer-events: none;\n}\n\n.container-dropdown-cadastros li {\n    padding: 0;\n}\n\n.container-dropdown-cadastros li a span {\n    padding-left: .6rem;\n}\n\n.dropdown-cadastros {\n    display: none;\n}\n\n.dropdown-cadastros a {\n    text-decoration: none;\n    color: var(--text-color2);\n    font-size: .9rem;\n    margin-top: .3rem;\n    margin-left: 3.7rem;\n    padding-top: .4rem;\n    padding-bottom: .4rem;\n    width: max-content;\n    min-width: 65%;\n    font-weight: bold;\n}\n\n.dropdown-cadastros a:hover {\n    background-color: var(--azul-desativado);\n    color: var(--texto-azul);\n}\n\n.sub-meun-dropdown {\n    display: flex;\n    align-items: center;\n}\n\n#tela-atual-sub-menu {\n    border-left: 5px solid var(--azul-dixi);\n    border-radius: 0 8px 8px 0;\n    color: var(--azul-dixi);\n}\n\n#nao-e-tela-atual-sub-menu {\n    border-radius: 8px;\n}\n\n.seta-dropdown-cadastros.tela-atual {\n    color: var(--branco-padrao);\n}\n\n.dropdown-aberto {\n    display: block;\n}\n\n.tooltip-navbar-lateral {\n    position: absolute;\n    width: max-content;\n    color: var(--text-color);\n    padding: .35rem .9rem;\n    font-size: 1rem;\n    font-weight: 600;\n    align-items: center;\n    left: 3.3rem;\n    top: .55rem;\n    border-radius: 1rem;\n    transition: all .3s ease-in-out;\n\n    transition: opacity 0.3s ease, visibility 0.3s ease;\n}\n\nmenu ul li a {\n    text-decoration: none;\n    color: var(--azul-dixi);\n    font-size: 1.3rem;\n    padding: .8rem 1rem .6rem 1rem;\n    border-radius: .8rem;\n    transition: all .3s;\n    width: 100%;\n}\n\nmenu ul li a:hover {\n    background: var(--botao-hover-clarinho);\n}\n\n#main-menu {\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.tela-atual a {\n    background: var(--azul-dixi);\n    color: var(--branco-padrao);\n}\n\n.tela-atual span {\n    color: var(--branco-padrao);\n}\n\nmenu:hover {\n    width: 14rem;\n}\n\n.tela-atual a:hover {\n    cursor: pointer;\n    background: var(--botao-hover);\n    color: var(--branco-padrao);\n}\n\n#menu-inferior {\n    margin-top: auto;\n    margin-bottom: 2rem;\n}\n\n.botao-sair a {\n    color: var(--vermelho-padrao);\n}\n\n.botao-sair a:hover {\n    background: var(--vermelho-padrao);\n    color: var(--branco-padrao);\n}\n\nli:hover .tooltip-navbar-lateral {\n    opacity: 1;\n    visibility: visible;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
